module.exports = __webpack_public_path__ + "img/silver-1.fa189eba.png";